export const VIACHAT_SET_USER = 'VIACHAT_SET_USER';
export const VIACHAT_RESET = 'VIACHAT_RESET';

export const ANALYTICS_IDENTITY = 'ANALYTICS_IDENTITY';
export const ANALYTICS_RESET = 'ANALYTICS_RESET';
